export default {
    payment_failed_please_contact_admin: 'Seu pagamento não pôde ser processado. Por favor, entre em contato com o suporte.',
    login: "Log In",
    forgot_password: "Esqueceu sua Senha?",
    english: "English",
    german: "Deutsch",
    french: "Français",
    italian: "Italiano",
    dutch: "Nederlands",
    spanish: "Español",
    portuguese: "Português",
    english_short: "EN",
    german_short: "DE",
    french_short: "FR",
    italian_short: "IT",
    dutch_short: "NL",
    spanish_short: "ES",
    portuguese_short: "PT",
    no_more_photos_for_moderation: "Não há mais imagens para moderar. Volte um pouco mais tarde. Obrigado pela sua ajuda 😘",
    invalid_token_message: 'Por motivos de segurança, o seu token de acesso expirou.\n' +
        '    Solicite um novo token para continuar.',
    try_again:'Tentar novamente',
    timezone: 'Fuso horário',
    timezone_type_automatic: 'O seu fuso horário será detectado automaticamente',
    timezone_type_manually: 'O fuso horário escolhido será bloqueado',
    add_links_to_profiles_events_clubs:'Adicione links a perfis, eventos e clubes',
    you_can_add_only_twenty_links: 'Você só pode adicionar 20 links',
    enter_your_social_network_handle: 'Insira o seu nome de usuário do {social_network}',
    follow: 'Seguir',
    message: 'Message',
    message_copied: 'Copiado com sucesso',
    copied_from_clipboard: 'Copied from clipboard',
    reply: "responder",
    copy: "copiar",
    delete_for_all: "excluir para todos",
    now: "AGORA!",
    meet_now:"Encontra AGORA!",
    activate_meet_now: "Ativa \"AGORA!\" e mostra que estás pronto/a para encontrar-te.",
    activate_now:"Ativa AGORA!",
    deactivate_now:"Desactiva ¡AHORA!",
    meet_now_mini_text:"„AGORA!” fica ativo por 30 minutos.",
    finished:"Acabado?",
    over_now:"...acabado AGORA!",
    headline_or_nickname:"Título ou Apelido",
    meet_now_upgrade_to_pro:"„AGORA!” foi ativado {0} vezes hoje. Fica PRO para reativar „AGORA!” sem limites.",
    activate_meet_now_n_times:"Ativa \"AGORA!\" até {0} vezes por dia. Membros PRO podem ativar sem limites.",

    email: "E-mail",
    email_or_username: "E-mail ou apelido",
    photo: "Foto",
    password: "tua senha",
    verify_age: 'Verificar idade',
    verifying_age: 'Verificando idade',
    verification_success_title: 'Verificação concluída',
    verification_success_desc: 'Sua idade foi verificada com sucesso.',
    verification_failed_title: 'Falha na verificação',
    verification_failed_desc: 'A verificação não foi aprovada. Você pode tentar novamente selecionando ou enviando uma foto diferente.',
    verification_limit_title: 'Limite Atingido',
    verification_limit_desc: 'Você excedeu o número máximo de tentativas de verificação de idade. Por favor, tente novamente mais tarde.',
    try_again_in: 'Tente novamente em',
    close: 'Fechar',
    okay: 'Ok',
    start_verification: 'iniciar verificação',
    choose_photo: 'Escolher foto',
    age_verification_photo_instruction: 'Por favor, forneça uma foto onde seu rosto esteja claramente visível. A foto deve conter apenas uma pessoa.',
    age_verification_description: 'Para verificar sua idade, siga as instruções.',
    verify_now: 'Verificar agora',
    stay_logged_in: "Ficar Logado?",
    new_to_barebuddy: "Novo no Buddy?",
    join_now: "Cadastre-se!",
    // what_is_barebuddy: "What is BareBuddy? Find out more",
    recover_password: "Recuperar Senha",
    reset_password: "Restaurar senha",
    confirm_password: "Confirmar Senha",
    recover_now: "Recuperar Agora",
    create: "Criar",
    start: "Começar",
    age_modal:{
        'age_check' : 'Verificação de idade',
        'contain_sensitive_material':'Esta página pode conter material sensível.',
        'you_need_eighteen':'Tens de ter mais de 18 anos para continuar.',
    },
    join_modal:{
        become_a_member: "Torna-te membro agora e aproveita todas as funcionalidades.",
        its_quick_and_free: "É rápido e grátis!",
        already_a_member:"Já és membro?",
    },
    passwords: {
        password: "Senha deve conter ao menos seis caracteres e ser igual à confirmação de senha",
        reset: "Sua senha foi alterada!",
        sent: "Se este email estiver registado, receberás uma link de recuperação.",
        token: "Link de alteração de senha inválido.",
        user: "Se este email estiver registado, receberás uma link de recuperação.",
    },
    welcome: {
        what_next: "O que gostarias de fazer a seguir?",
        nickname: "Apelido",
        nickname_description: "Completa teu perfil agora.",
        discover: "Descobre BUDDY",
        discover_description: "Bate-papo, encontro, relaxamento, guia e muito mais para descobrir.",
        pro: "Atualizar para Pro",
        pro_description: "Diversão infinita com a versão Pro."
    },
    invalid_credentials: "Dados de usuário incorretos.",
    reg: {
        // step1: "Step 1",
        // step2: "Step 2",
        // step3: "Step 3",
        ready: "Pronto",
        automatic_location: "Localização automática",
        manual_location: "Localização manual",
        location_defining: "Definição de localização...",
        choose_password: 'Escolhe uma senha',
        password_looks_good: "A tua senha está boa.",
        pick_nickname: "Escreva um apelido para o seu perfil de Buddy.",
        nickname: "Apelido",
        pick_handle: "Este é o seu link de Buddy:",
        suggestions: 'Sugestões',
        upload_photo: "Carregar fotografia",
        handle_available: "O link de Buddy está disponível.",
        handle_already_taken : "Este link de Buddy já está em uso.",
        password_description: "sua senha deve ser mínima. 6 caracteres de comprimento",
        handle_description : "O seu link de Buddy ajuda os outros a encontrarem o seu perfil. Pode alterá-lo agora ou mais tarde nas configurações.",
        birthdate: "Data de nascimento",
        next: "Continuar",
        enter_email_address: "Teu e-mail",
        almost_finished: "Quase Terminando...",
        add_photo_text: "Adicione uma fotografia para que os buddies o possam ver.",
        i_am_ready: "Tudo Pronto",
        skip: "Saltar",
        back: "Voltar",
        add_photo: "Adicionar Foto",
        you_made_it: "Você Conseguiu!",
        accept_terms_privacy_text: "Ao premir \"Continuar\", asseguro que tenho 18 anos ou mais e que li a {0} e aceitei os {1}.",
        accept_terms_privacy_text_barebuddy: "By entering, you agree to our {0} and {1}.",
        terms_of_service: "Terms of Service",
        you_must_be_eighteen: "You must be over 18 years old to enter",
        terms_of_use: "Termos de Utilização",
        privacy_policy: "Política de Privacidade",
        finish: "Finalizar",
        cancel: "Cancelar",
        upload: "Carregar",
        welcome_to_bb: "Bem-vindo ao BUDDY",
        where_are_you_located: "Qual a sua localização?",
        use_current_location: "Utilizar localização atual",
        choose_location_manually: "Selecionar localização manualmente",
        lets_go: "Pronto",
        human_verification_required: "Por favor, preencha o Captcha para continuar",
        try_another_photo: "tente outra foto",
        map: "Mapa",
        use_gps: "Utilizar GPS",
        gps: "GPS",
        type_address: "Digite seu Endereço",
    },
    links: {
        about_us: "Sobre Nós",
        imprint: "Imprimir",
        support: "Ajuda",
        terms: "Termos de Uso",
        community_guidelines: "Diretrizes da Comunidade",
        privacy: "Declaração de Privacidade",
        billing_support: "Ajuda com Pagamentos",
    },
    profile_preview: 'Pré-visualização do perfil',
    public_gallery: 'Galeria pública',
    nearby: "Nas Proximidades",
    recent: "Recente",
    shuffle: "Shuffle",
    favorites: "Favoritos",
    favorites_online: "Favoritos online",
    online: "On-line",
    send_photo: "Enviar Foto",
    send_location: "Enviar Localização",
    set_location: "Configurar Localização",
    type_something: "Digite Algo",
    all: "Tudo",
    unread: "Não lido",
    pos_of_total: "{posição} de {total}",
    block_user: "Bloquear Usuário",
    report_user: "Report user",
    user_not_found: 'Usuário não encontrado',
    cancel: "Cancelar",
    online_now: "On-line Agora",
    away: "On-line Há Pouco",
    offline: "Ausente",
    about: "Sobre",
    height: "Altura",
    weight: "Peso",
    body: "Corpo",
    position: "Posição",
    penis: "Pau",
    hiv: "Estado",
    drugs: "Candy",
    info: "Informações",
    stats: "Perfil",
    photos: "Fotos",
    settings: "Configurações",
    share: "Participação",

    open_mailbox: 'Abrir caixa postal',

    about_me: "Sobre",
    tags: "Tags",
    access: "Acesso",
    profile_account: "Conta",
    account: "Conta",
    logout: "Sair",
    preferences: "Preferências",
    show_age: "Mostrar Idade",
    yes: "Sim",
    no: "Não",
    join: "Cadastre-se",
    host: "Anfitrião",
    member: "Membro",
    language: "Língua",
    unit_system: "Sistema de unidade",
    metric: "Métrico",
    imperial: "Imperial",
    website_design: "Design do site",
    old: "Antigo",
    reset: "Redefinir",
    unblock_users: "Desbloquear usuários",
    delete_my_profile: "Apagar Meu Perfil",
    your_profile_picture: "Foto de Perfil",
    public_pictures: "Fotos Públicas",
    can_select_count: "{count} de {total}",
    make_photo_private: "Tornar Foto Privada",
    make_photo_public: "Tornar Foto Pública",
    set_profile_picture: "Tornar Foto do Perfil",
    delete_photo: "Apagar Foto",
    display_name: "Apelido",
    display_link : 'Buddy link',
    display_club_link_or_title: 'clublink or title',
    location: "Localização",
    support: "Ajuda",
    photo_message: "Mensagem via Foto",
    distance_away: "{distance} de distância",
    set_current_location: "Configurar Localização Atual",
    location_message: "Mensagem de Localização",
    no_users_around: "Não há Buddies por perto",
    no_more_users_around: "Não há mais Buddies por perto",
    to_see_members_become_a_member: 'Para ver mais utilizadores, torna-te membro.',
    no_chat_messages: "Histórico de conversas vazio",
    no_more_chat_messages: "Não há mais mensagens em seu histórico",
    message_not_delivered: "não entregue - toque para enviar novamente",
    old_password: "Senha Antiga",
    new_password: "Nova Senha",
    new_password_confirmation: "Confirmar Senha",
    password_modified: "Sua senha foi alterada com sucesso",
    wrong_old_password: "Sua senha antiga está incorreta",
    save: "Salvar",
    are_you_sure_delete_profile: "Tem certeza que deseja apagar seu perfil?",
    all_users_unblocked: "Todos os usuários foram desbloqueados",
    no_tags: "adicione tags aqui",
    add_tag: "digite uma tag e clique em Retornar",
    link_copied: "Link copiado",

    write_us_help: "Fale conosco para pedir Ajuda, fazer Sugestões e Mais!",
    automatic_location: "Detecção Automática",
    manual_location: "Configurar Localização Manualmente",
    address: "Endereço",
    fail_load_location: "Falha ao obter localização. Gostaria de adicionar sua localização manualmente?",
    fail_auto_choose_manual_location: "Falha ao obter localização. Por favor, adicione sua localização manualmente",
    this_is_profile_picture: "Sua foto de perfil",
    sure_delete_conversation: "Apagar histórico de conversas?",
    failed_load_user: "Falha ao carregar perfil do usuário",
    please_register: "Registre-se",
    recover_it: "Recuperar Senha", //we talk here about forgotten 'password' on login form
    not_a_member: "Ainda não é Membro?",
    fail_block_user: "Falha ao Bloquear Usuário",
    user_reported_confirmation: "Obrigado por reportar usuário. Iremos verificar o quanto antes",
    register_here: "Registre-se Aqui",
    options: {
        body: {
            slim: "Magro",
            average: "Na Média",
            athletic: "Atlético",
            muscular: "Sarado",
            stocky: "Cheinho"
        },
        position: {
            top: "Ativo",
            more_top: "Mais ativo",
            bottom: "Passivo",
            more_bottom: "Mais passivo",
            versatile: "Versátil"
        },
        hiv: {
            positive: "Positivo",
            negative: "Negativo",
            undetectable: "Indetectável",
            prep: "PrEP",
            unknown: "Desconhecido"
        },
        drugs: {
            yes: "Sim",
            no: "Não",
            socially: "Por vezes",
        }
    },
    Sunday: "Domingo",
    Monday: "Segunda",
    Tuesday: "Terça",
    Wednesday: "Quarta",
    Thursday: "Quinta",
    Friday: "Sexta",
    Saturday: "Sábado",
    January: "Janeiro",
    February: "Fevereiro",
    March: "Março",
    April: "Abril",
    May: "Maio",
    June: "Junho",
    July: "Julho",
    August: "Agosto",
    September: "Setembro",
    October: "Outubro",
    November: "Novembro",
    December: "Dezembro",
    back: "Voltar",
    report_harassment: "Assédio",
    report_fake: "Fake",
    report_spam: "Spam",
    report_under_age: "Menor de idade",
    report_other: "Outro",
    cookies_message: "Os cookies nos ajudam a oferecer nossos serviços. Ao usar nossos serviços, você concorda com o uso de cookies. ",
    learn_more: "Saiba Mais",
    profile_is_deleted: "Perfil apagado",
    crop_photo: "Editar Foto",
    install_pwa_ios_message: "Instale BUDDY em seu celular: tap <img src=\"/assets/img/iphone-share-btn.jpg\" style=\"height: 26px\" /> and then <strong>Add to Home Screen</strong>: <img style=\"height: 30px\" src=\"/assets/img/add-home-screen-en.png\" />",
    you_are_offline: "Você parece estar off-line",
    show_map: "Mapa",
    subscribe_to_newsletter: "Boletim Informativo",
    emails_reminders: "Resumo de E-mail",
    daily: "Diário",
    weekly: "Semanal",
    monthly: "Mensal",
    never: "Nunca",
    "validation.imageable": "Tipo de imagem não suportado. Carregue apenas imagens JPG, PNG ou GIF. ",
    user_blocked_confirmation: "Usuário bloqueado",
    search_users: "Apelido",
    sure_delete_event: "Deletar Evento?",

    home: {
        come_inside: 'Entra',
        content_removal : "Remoção de conteúdo",
        bad_boys_society: "Bad Boys Society",
        create_account: "Criar conta",
        tagline: "BUDDY",
        fun: "Construindo um app gay melhor",
        login: "E-mail ou Apelido",
        password: "Senha",
        log_in: "Entrar",
        remember_me: "Lembrar",
        forgot_password: "Esqueceu a Senha?",
        new_here: "Novo por Aqui?",
        sign_up: "Cadastre-se",

        wants: "Mostre o seu lado kinky.",
        wants_desc: "Experiente ou curioso - faça parte da comunidade BUDDY e explore seus kinks. Mande taps e comece a conversar na hora. Procure por hashtags para encontrar rapidamente kinksters que combinem com você.<br><br>Encontros excêntricos mais rápido do que nunca.",

        videos: "Assista e compartilhe videos.",
        videos_desc: "Assista a muitos vídeos de membros gostosos. Compartilhe seus vídeos pré-gravados no privado ou em seu perfil público.<br><br>Nunca foi tão divertido.",

        calendar: "Divirtam-se juntos.",
        calendar_desc: "Crie classificados privados em nosso calendário. Mostre pros outros, o que você quer e quando você quer. Tá afim de mais? Organize grupos e conheça novos contatinhos.<br><br>Conheça kinksters como você.",

        everywhere: "Então... qual é o seu kink?",
        everywhere_desc: "Use nosso site sem censura, ou baixe o aplicativo BUDDY.<br><br>Acesse agora e experimente!",

        generation: "Seja bem-vinde ao Buddyverso",
        generation_desc: "Acreditamos que podemos servir melhor a nossa comunidade tornando o BUDDY acessível a todes. Diferente dos outros aplicativos, a gente oferece as funções mais úteis, totalmente de  graça. Ilimitado, sem anúncios irritantes. Queremos nos tornar o melhor e maior aplicativo gay para o lifestyle kinky e fetichista. Junte-se agora e espalhe a palavra.<br><br>Mais buddies - mais diversão!",

        sign_up_now: "Cadastre-se",

        company: "Empresa",
        about_us: "Sobre Nós",
        blog: "Blog",
        help: "Ajuda",
        support: "Ajuda com Pagamento",

        legal: "Jurídico",
        privacy: "Declaração de Privacidade",
        terms: "Termos de Uso",
        community_guidelines: "Diretrizes da Comunidade",
        usc: "18 U.S.C. 2257",
        imprint: "Imprimir",

        languages: "Línguas",
        follow_us: "Siga-nos"
    },

    home_old: {
        tagline: "Buddies<br/>&<br/>Benefits",
        easy_raw_free: "MEET MEN ON PREP",
        // responsible_dating: "Responsible bareback dating",
        home_text: `Come inside and meet gay guys near you.
            BUDDY is the first network
            for men on PrEP or TasP.`,
        join_start: "Join now and start dating immediately.",
        get_started: "Get started",
        screen_title1: "Easy.",
        screen_sub1: "On the hunt!",
        screen_text1: "Browse profiles, chat and send your videos with ease.",
        screen_title2: "FUN.",
        screen_sub2: "Pure and natural!",
        screen_text2: "No discussions, no judgement. Save your time. Just chat and meet.",
        screen_title3: "Free.",
        screen_sub3: "Join for free.",
        screen_text3: "Unlimited profile views, messages and pictures. BUDDY lets you have unlimited fun.",
    },

    company: "Empresa",
    legal: "Jurídico",
    community_guidelines: "Diretrizes da Comunidade",
    social_media: "Mídias Sociais",
    edit_your_photo: "Tu és linda!",
    complete_profile: "Completar Meu Perfil",
    add_more_photos: "Adicionar Mais Fotos",
    check_out_guys: "Ver Buddies",
    members_login: "LOgin de Membros",
    change_password: "Alterar Senha",
    create_your_event_plus: "Crie seu Evento clicando em +",
    create_new_event: "Criar novo evento",
    create_event: "Criar evento",
    create_your_club_plus: "Crie seu Clube clicando em +",
    create_new_club: "Criar novo clube",
    create_club: "Criar clube",
    title: "Título",
    date: "Data",
    time: "Hora",
    add_event_details: "Adicionar detalhes",
    event_description: "Descrição de Evento",
    club_description: 'Descrição',
    club_description_placeholder: 'O que é o seu clube?',
    joined_to_club: "se juntou",
    left_to_club: "saiu",
    private: "Private",
    public: "Public",
    non_commercial: "non-commercial",
    commercial: "commercial",
    add_tags_optional: "Adicionar tags (opcional):",
    select_address: "Selecionar Endereço",
    location_details: "Detalhes do Local (opcional)",
    location_example: "(eg: my flat, venue name)",
    full_address: "Full address",
    city_only: "Only city",
    event_choose_photos: "Selecionar Fotos para Evento",
    club_choose_photos: 'Selecionar Fotos para Clube',
    display: "Mostrar:",
    alternative: '',
    hot: "foto sexy (opcional)",
    preview: 'imagem segura',
    for_censored_app: "para aplicativo censurado",
    visible_only_uncensored_website: "visível apenas no site não censurado",
    preview_picture: "Visualizar Foto",
    submit_event: "Enviar",
    event_address: "Endereço de Evento",
    club_address: 'Cidade',
    please_select_preview_picture: "Selecione a imagem de visualização",
    set_preview_picture: "Definir como imagem de visualização",
    event_successfully_added: "Seu evento foi adicionado com sucesso",
    event_successfully_updated:"O seu evento foi atualizado com sucesso.",
    no_events_around: "Não há eventos por perto",
    no_more_event_around: "Não há mais eventos por perto",
    club_successfully_added: 'Seu clube foi adicionado com sucesso',
    no_clubs_around: 'Não há clubes por perto',
    no_more_club_around: 'Não há mais clubes por perto',
    edit: "Editar",
    recipient_will_not_see_you: "O recipiente não verá o seu perfil.",
    public_videos: "Vídeos Públicos",
    send: "Enviar",
    event_choose_videos: "Escolha vídeos para o seu evento",
    delete_video: "Apagar Vídeo",
    add_video: "Adicionar Vídeo",
    videos: "Vídeos",
    play_video: "Reproduzir Vídeo",
    video_uploaded_processing: "Seu vídeo foi enviado com sucesso e agora está sendo processado. Notificaremos você assim que estiver pronto.",
    video_processed: "Seu vídeo está pronto e já pode ser usado",
    video_message: "Mensagem de Vídeo",
    sure_delete_photo: "Apagar Foto?",
    sure_delete_video: "Apagar Vídeo?",
    too_hot: "Muito quente",
    notifications: "Notificações",
    push_notifications: "Notificações Push",
    help: "Ajuda",
    profile: "Perfil",
    user_blocked: "Você bloqueou este usuário ou ele bloqueou você.",
    open_blocked_users: "Abrir lista de usuários bloqueados",
    faq: "FAQ",
    support_chat: "Ajuda via Chat",
    click_here_tutorials: "Clique Aqui para Tutoriais",
    send_direct_message: "Nos envie uma mensagem",
    app: "App",
    security: "Segurança",
    notification_sound: "Sons de Notificação",
    deactivate_my_profile: "Desativar Perfil",
    deactivate_or_delete_my_profile: "Desativar ou Apagar Conta",
    customize_sharing_links: "Personalizar links de compartilhamento",
    delete_all_sharing_links: "Excluir todos os links de compartilhamento",
    delete_all: "Excluir tudo",
    deactivate_account: "Desativar Conta",
    taking_break_buddy: "Quer sair um pouco do BUDDY?",
    deactivate_text_description: "Desative o seu perfil e desapareça completamente do radar e pesquisa.",
    deactivate: "Desativar",
    delete_profile_text: "Se quiser sair do BUDDY para sempre, {0} ao excluir o seu perfil. Isso é permanente e não pode ser desfeito e você precisará criar um novo perfil quando quiser voltar. Lembre-se de que todo amigo precisa de um pouco do BUDDY :-)",
    click_here: "Clique Aqui",
    are_you_sure_deactivate_profile: "Tem certeza que deseja desativar o seu perfil?",
    inactive_profile: "Perfil Inativo",
    account_is_deactivated: 'Seu adorável perfil BUDDY está atualmente desativado. <br /> Clique em "Ativar" para voltar.',
    activate: "Ativar",
    leave: "Sair",
    profile_is_deactivated: "Perfil Desativado",
    prep_safer_use: "PrEP, TasP, STD, Safer use",
    information_education: "Information & Education",
    prep_chat: "PrEP Chat",
    channel_prep_questions: "Channel for 1:1 PrEP questions",
    censored_event_title: "***Content Warning***",
    censored_event_description: "***This event may contain sensitive material*** <br /><br />Your media settings are configured to warn you about sensitive material. <br />To view it, you need to change your selection in your safety settings",
    censored_content_warning: "Suas configurações de mídia são configuradas para avisá-lo sobre materiais confidenciais. <br /> <br /> Para visualizá-lo, você precisa alterar sua seleção nas configurações de segurança ",
    change_settings: "Alterar Configurações",
    show_more: "Mostrar Mais...",
    display_sensitive_events: "Mostrar Eventos Sensíveis",
    display_sensitive_media: "Mostrar Mídia Sensível",
    tiles: "Ladrilhos",
    list: "Lista",
    filter: "Filtro",
    pics: "Fotos",
    age: "Idade",
    new: "Novo",
    ok: "OK",
    taps: "Acessos",
    visitors: "Visitantes",
    visited: "Vistos",
    no_visitors: "Sem Visitantes Ainda",
    no_more_visitors: "Sem Mais Visitas",
    no_visited: "Sem Visitas Ainda",
    no_more_visited: "Sem Mais Visitas",
    no_taps: "Sem Acessos",
    no_more_taps: "Sem Mais Acessos",

    discreet_mode: "Invisível",
    discreet_mode_on: "Mask Mode (ON)",
    discreet_mode_off: "Mask Mode (OFF)",

    hide_profile_completely: "Ocultar Perfil Completamente",
    upgrade_to_pro: "Tornar-se PRO",
    upgrade_to: "Upgrade a",
    upgrade_now: "Faça um Upgrade Agora",
    upgrade: "Upgrade",
    click_here_to_upgrade: "Clique aqui para fazer upgrade",
    click_here_to_cancel: "Clique aqui para cancelar",
    pro: "PRO",
    cancel_pro: "Cancelar PRO",
    thank_you_for_being_a_pro: "Obrigado por ser um BUDDY Pro",
    successful_pro_upgrade: "Você é agora um BUDDY Pro!",
    failed_pro_upgrade: "Opa...algo deu errado",
    we_hope_you_enjoyed_pro: "Esperamos que tenha curtido o Buddy Pro",

    delete_this_message: "Apagar Mensagem?",
    delete: "Apagar",
    removed: "Removido",

    pro_slides_1_title: "Invisível",
    pro_slides_1_description: "com Modo Máscara",
    pro_slides_2_title: "Cancelar Mensagens",
    pro_slides_2_description: "verificar se ele leu<b> sua mensagem",
    pro_slides_3_title: "Mais Filtros",
    pro_slides_4_title: "Ilimitado",
    pro_slides_4_description: "favoritos, bloqueios,visitantes,<br>fotos públicas e vídeos",
    pro_slides_5_title: "Mais Diversão",
    pro_slides_5_description: "ver todos os vídeos e fotos",

    notifications_button: 'Ativar notificações',
    splash_notifications_title: 'Mantenha-se atualizado',
    splash_notifications_description: 'Por favor, ative as notificações para receber mensagens e alertas de seus buddies',

    splash_blocks_title: "Bloqueios ilimitados",
    splash_blocks_description: "para bloqueios ilimitados faça o upgrade para",
    splash_favorites_title: "Favoritos ilimitados",
    splash_favorites_description: "Para favoritos ilimitados faça o upgrade para",
    splash_mask_title: "Invisível",
    splash_mask_description: "Para Invisível faça o upgrade para",
    splash_censored_title: "Veja mais",
    splash_censored_description: "Para conteúdo ilimitado faça o upgrade para",
    splash_visitors_title: "visualizações do meu perfil",
    splash_visitors_description: "para ver todos os seus visitantes faça o upgrade para",
    splash_filters_title: "Mais filtros",
    splash_filters_description: "Para mais filtros faça o upgrade para",
    splash_media_title: "Fotos públicas e vídeos ilimitados",
    splash_media_description: "Para fotos e vídeos ilimitados faça o upgrade para",
    splash_deletemsg_title: "Apagar mensagem",
    splash_deletemsg_description: "Para apagar mensagem faça o upgrade para",
    splash_change_settings_title: "Suas configurações de mídia são configuradas para avisá-lo sobre materiais confidenciais.",
    splash_change_settings_description: "Para visualizá-lo, você precisa alterar sua seleção nas configurações de segurança.",
    splash_events_title: "Mais eventos",
    splash_events_description: "Para mais eventos, faça o upgrade para",

    pro_upgrade_message_desktop: "As assinaturas serão renovadas automaticamente, a menos que sejam canceladas dentro de 24 horas antes do final do período atual. <br> Visite <a href=\"http://cs.segpay.com\"> SEGPAYEU.COM </a>, nosso agente de vendas autorizado. <br> As cobranças aparecerão no extrato do seu cartão de crédito como <a href=\"http://cs.segpay.com\"> SEGPAYEU.COM * BUDDY </a>. ",
    pro_upgrade_message_mobile: "As assinaturas serão renovadas automaticamente, a menos que sejam canceladas dentro de 24 horas antes do final do período atual.",
    payment_blocked: "Pedido de Pagamento em Processamento.",
    you_cant_send_messages_to_this_user: "Não é possível enviar mensagem a este usuário.",

    events: {
        report: {
            title: "Reportar Evento",
            wrong_type: "Categoria errada",
            illegal: "Ilegal",
        },
        type: {
            friends: 'Friends',
            fun: 'Date',
            bang: 'Chill',
            guide: 'Guide',
            chemsfriendly: "chemsfriendly",
            required: "Por favor selecione uma categoria",
        },
        date: {
            today: "hoje",
            tomorrow: "amanhã",
            pick_date: "data"
        },
        link_my_profile: "Conectar meu perfil",
        not_found: "Evento não encontrado",
        report_success: "Obrigado por reportar evento. Iremos analisá-lo o mais breve possível",
        new_event: "Novo evento",
        new_bang: "New bang",
        my_events: "Meus eventos",
        publish: "Publicar",
        select_type: 'Que tipo de evento gostarias de criar?',
        about_guide: "eventos públicos para todos (festas, festivais, comunidade)",
        about_fun: "encontra um buddy para actividades privadas (1:1)",
        about_bang: "organiza eventos de grupo privados",
        invitation_only_event: "apenas convite (evento privado)",
        please_add_favourite_buddies_first: "Adiciona os teus buddies favoritos primeiro",
        accept: "Aceitar",
        decline: "Declinar",
        invited: "Convidado",
        invite: "Convidar",
    },

    clubs: {
        admin: 'Admin',
        invites: 'Invites',
        member: 'Member',
        nearby: 'Nearby',
        more_clubs: 'Mais clubes',
        hide_club_admin: "Ocultar o administrador do clube",
        report: {
            title: "Reportar Clube",
            wrong_type: "Categoria errada",
            illegal: "Ilegal",
        },
        type: {
            discover: 'Descobrir',
            my_clubs: 'Meus clubes',
            chemsfriendly: "chemsfriendly",
            required: "Por favor selecione uma categoria",
        },
        date: {
            today: "hoje",
            tomorrow: "amanhã",
            pick_date: "data"
        },
        not_found: "Clube não encontrado",
        report_success: "Obrigado por reportar clube. Iremos analisá-lo o mais breve possível",
        new_club: 'Novo clube',
        my_clubs: 'Meus clubes',
        publish: 'Publish',
        invitation_only_club: "apenas convite (clube privado)",
        write_to_support_to_open_club: "Escreva para o suporte se quiser alterar a privacidade deste clube",
        please_add_favourite_buddies_first: "Adiciona os teus buddies favoritos primeiro",
        accept: "Aceitar",
        decline: "Declinar",
        invited: "Convidado",
        invite: "Convidar",
    },

    payment: {
        coming_soon: "Em breve",
        month: "por mês",
        one_month: "mês",
        three_months: "meses",
        twelve_months: "meses",
        your_promotion_code: "Seu código promocional",
        please_select_payment_option: "Por favor selecione opção de pagamento.",
        use_promo_code: "Use um código PROmocional",
        credit_card: "Cartão de Crédito",
        alternative_payments: "Meios de pagamento alternativos",
        renews_automatically_until_cancelled: "Renova automaticamente até cancelamento.",
        active_until: "Seu status PRO ativo até",
        one_time: "Uma vez",
        no_need_to_cancel: "(Não é necessário cancelar!)",
        upgrade: {
            one_month: "Upgrade por 1 Mês",
            three_months: "Upgrade por 3 Meses",
            twelve_months: "Upgrade por 12 Meses",
        },
        upgrade_paypal: {
            one_month: "PayPal por 1 Mês",
            three_months: "PayPal por 3 Meses",
            twelve_months: "PayPal por 12 Meses",
        },
        send:"Enviar",
        thank_you: "Obrigado!",
        return_to_buddy: "Voltar para BUDDY",
        paypal: {
            message: "<p>Por favor, insere teu endereço de e-mail do PayPal.</p><br /><p>A gente vai te enviar um link do PayPal para esse endereço.</p><br /><p>Depois que a gente receber o pagamento, a gente vai fazer um upgrade no teu perfil Buddy.</p>",
            successMessage: "<p>Recebemos a tua solicitação de upgrade.</p><br/><p>Vamos enviar-te um link do Paypal em breve.</p><br /><p>Depois de recebermos o pagamento, <br/> por favor, dá-nos algum tempo para realizar <br/>o teu upgrade.</p> <br /><p>Fazemos isso à mão! ✊🏻💦</p>"
        },
        features: {
            unlock_filters : "Desbloquear todos os filtros",
            be_invsble: "Ficar invisível",
            see_all_who_viewed_me: "Ver todos que me visualizaram",
            remove_messages: "Remover mensagens",
            make_notes_on_profile: "Fazer anotações nos perfis",
            unlimited_favorites: "Favoritos ilimitados",
            view_hot_medias: "Ver mídia XXX no aplicativo",
            see_if_your_message_has_been_read: "Ver se sua mensagem foi lida",
            see_wh_marked_you_favorite: "Ver quem te marcou como favorito",
            hide_profile_visits: "Ocultar visitas ao perfil"
        }
    },

    uploadVideos: {
        error: {
            lowDuration: "A duração do vídeo deve ser superior a 1 segundo.",
            highDuration: "A duração do vídeo deve ser inferior a 15 minutos.",
        },
    },

    rush: {
        running_for_x_days: "Em execução por {dias} dia (s)",
        stars_and_strips_upgrade: "Estrelas e strips. Atualize para",
        announce: "<span> Olá amigos, </span> <span> os criadores do Buddy criaram algo novo para você. </span> <span> {0} são pequenos aplicativos dentro do BUDDY, que são úteis e divertidos, </span> <span> Divirta-se ao explorar! </span> ",
        how_to: {
            title: "RUSH - Como...",
            create: "Crie seu strip",
            name: "Nomeie seu strip",
            media: "Selecione uma foto ou escreva algo",
            publish: "Publique seu strip e adicione mais conteúdo",
        },
        welcome: {
            title: "Bem-vindo ao RUSH",
            story: {
                title: "Sua própria história.",
                description: "Adicone fotos ao seu strip e mostre-o aos seus buddies.",
            },
            post: {
                title: "Poste todos os dias.",
                description: 'Faça um "Rush" durar mais e receber mais aplausos.',
            },
            applause: {
                title: "Mais aplausos?!",
                description: "Isso lhe dá uma visualização maior do bloco. Isso significa mais visualizações no buddy! ",
            },
            attention: {
                title: "Atenção!",
                description: "Se não houver nenhuma nova foto em 24 horas, sua strip desaparece. O 'Rush' acaba. ",
            },
        },
    },
    sure_unblock_user: "Desbloquear este perfil?",

    party_on_buddies1: "PARTY ON,",
    party_on_buddies2: "BUDDIES!",
    party_on_text1: "There is something new in the Buddyverse. Check out the new \"Guide\" section in our calendar and find parties and events nearby.",
    party_on_text2: "After two years it's about time we go out again and have fun! Let's support event organisers together and rock the party.",

    are_you_sure_you_want_to_delete_all_sharing_links: "Tem certeza de que deseja excluir todos os links de compartilhamento?",
    all_links_will_be_deactivated: "Todos os links serão desativados.",
    all_sharing_links_deleted_successfully: "Todos os links de compartilhamento foram excluídos com sucesso",
    this_is_your_sharing_code: "Este é o teu link de partilha (clica para copiar)",
    share_your_selected_videos: "Partilhe os teus vídeos seleccionados com<br>os tipos que ainda não estão no Buddy.",
    send_via_whatsapp: "Partilhar via Whatsapp",
    tap_on_the_videos_you_want_to_share: "Toca nos vídeos que queres partilhar",
    cancel_share: "Cancelar",
    share_now: "Partilhar",
    status:"Status",
    you_need_to_be_a_pro_for_editing:"Você precisa ser um <strong>PRO</strong> para edição",
    expire_at_date:"Expira na data",
    expire_at_time:"Expirar na hora",
    views_limit:"Limite de visualizações",
    you_dont_have_any_links:"Você não tem links",
    link_settings_saved:"Configurações de link salvas",
    can_not_get_sharing_links:"Não é possível obter links de compartilhamento",
    copied_to_clipboard: "copiado para prancheta",
    share_whatsapp_test: "Aqui está o link para o meu vídeo em buddy.net:",
    share_videos: 'Compartilhar vídeos',
    accept_all: 'Aceitar tudo',
    no_messages : 'Sem mensagens',
    you : 'Você',
    has: 'se',
    have: '',
    joined: 'juntou',
    left: 'deixou',
    web_push_notifications: 'Notificações push da Web',
    modal_pro_upgrade_description : 'Desfruta desta e de muitas outras funcionalidades se atualizares para PRO.',
    modal_pro_visit_upgrade_description : 'Ocultar a tua visita a este perfil com PRO',
    note : 'Observação',
    note_textarea_placeholder : "Adicione informações pessoais sobre este perfil...",
    who_marked_me_favorite : "Quem me marcou como favorito",
    cancel_failed: "O cancelamento falhou, tente novamente",
    subscription_canceled: "Assinatura cancelada",
    confirm_cancel: "Tem certeza de que deseja cancelar a assinatura?",
    cancel_subscription: "Cancelar assinatura"
}
